<template>
    <v-card flat class="site-wrapper">
        <v-card :loading="isLoading" elevation="3" rounded="lg" class="login-wrapper">
            <v-card-title class="page-title">Login</v-card-title>
            <v-form class="login-text-field-wrapper" v-if="!tokenRequested" @submit.prevent="login">
                <v-card-text>
                    <v-text-field class="login-text-field" label="Username" v-model="username" />
                    <v-text-field class="login-text-field" label="Password" type="password" v-model="password" />
                </v-card-text>
                <v-card-actions>
                    <v-btn rounded="lg" type="submit" :loading="isLoading" elevation="3" variant="outlined" class="login-btn">Login</v-btn>
                </v-card-actions>
            </v-form>
            <v-form v-if="tokenRequested" @submit.prevent="verifyToken">
                <v-card-text>
                    <v-text-field class="login-text-field" label="2FA Token" v-model="token" />
                </v-card-text>
                <v-card-actions>
                    <v-btn rounded="lg" type="submit" :loading="isLoading" elevation="3" variant="outlined" class="login-btn">Verify Token</v-btn>
                </v-card-actions>
            </v-form>
        </v-card>
        <div class="login-impressum">
            <v-btn rounded="lg" class="gradient-color-primary" href="https://www.lead-table.com/impressum">Impressum</v-btn>
        </div>
    </v-card>
</template>

<script>
import { mapState } from 'vuex';
export default {
    data() {
        return {
            username: '',
            password: '',
            token: '',
            tokenRequested: false,
        };
    },
    computed: {
        ...mapState('loginAndOut', ['isLoading']),
    },
    methods: {
        async login() {
            try {
                await this.$store.dispatch('loginAndOut/login', {
                    username: this.username,
                    password: this.password,
                });
                this.tokenRequested = true;
            } catch (error) {
                console.error("Login failed: ", error);
            }
        },
        async verifyToken() {
            try {
                await this.$store.dispatch('loginAndOut/verifyToken', {
                    username: this.username,
                    token: this.token,
                });
            } catch (error) {
                console.error("Token verification failed: ", error);
            }
        },
    },
}
</script>



<style lang="scss" scoped>
.login-wrapper {
    display: flex;
    flex-direction: column;
    width: 100%;
    max-width: 600px;
    align-items: center;
    margin: 64px auto;
    padding: 24px;
}

.login-text-field-wrapper {
    display: flex;
    flex-direction: column;
    width: 100%;
    max-width: 600px;
}

.login-btn {
    margin: 0 auto;
}

.login-impressum {
    display: flex;
    justify-content: center;
    margin-top: 24px;
}
</style>